import React from "react";


const StatisticsBox = ({ content }) => {
  return (
    <div className="statistics-box border border-dark rounded">
      <div className="d-flex flex-column gap-1 justify-content-center align-items-center text-center"
           style={{
             color: "#fde047",
             fontWeight: "bold"
           }}
           dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default StatisticsBox;